import { render, staticRenderFns } from "./luckyStarRecords.vue?vue&type=template&id=db61e0b4&scoped=true&"
import script from "./luckyStarRecords.vue?vue&type=script&lang=js&"
export * from "./luckyStarRecords.vue?vue&type=script&lang=js&"
import style0 from "./luckyStarRecords.vue?vue&type=style&index=0&id=db61e0b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db61e0b4",
  null
  
)

export default component.exports